import { useContext } from 'react';
import { CampaignContext } from '../BaseSendEditor.context';

export default () => useContext(CampaignContext);
